import React from 'react';
import invert from 'lodash/invert';
import isNil from 'lodash/isNil';
import {
	type StatusCategoryKeys,
	StatusCategoryTypes,
	StatusCategoryIds,
} from '@atlassian/jira-common-constants/src/status-categories';
import { useFieldValue } from '@atlassian/jira-issue-field-base';
import { StatusKey } from '@atlassian/jira-providers-issue';
import StatusFieldStatic from '../../card/card-contents/status-field/status-field-static';

export const StatusLite = ({
	issueKey,
	isUserAtLeastMember,
}: {
	isUserAtLeastMember: boolean;
	issueKey: string;
}) => {
	const [statusFieldValue] = useFieldValue({
		issueKey,
		fieldKey: StatusKey,
	});

	if (isNil(statusFieldValue) || !statusFieldValue.id || !statusFieldValue.name) {
		return null;
	}

	const value = {
		id: statusFieldValue.id,
		name: statusFieldValue.name,
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		category: (invert(StatusCategoryIds)[statusFieldValue.statusCategory.id] ||
			StatusCategoryTypes.UNDEFINED) as StatusCategoryKeys,
	};

	return <StatusFieldStatic isUserAtLeastMember={isUserAtLeastMember} value={value} />;
};
